
export const isAuthenticated = (state) => {
  return state.isLoggedIn && state.token != ''
}

export const getToken = (state) => {
  return state.token
}

export const getRoles = (state) => {
  return state.roles
}

export const getName = (state) => {
  return state.name
}

export const getEmail = (state) => {
  return state.email
}

export const getPhone = (state) => {
  return state.phone
}

export const hasRole = (state) => (role) => {
  return state.roles.find(curRole => {
    return curRole === role
  })
}

export const hasReceiveRole = (state) => {
  return state.roles.some(curRole => curRole === 'ROLE_RECEIVE')
}

export const hasTransferRole = (state) => {
  return state.roles.some(curRole => curRole === 'ROLE_TRANSFER')
}

export const hasAdminRole = (state) => {
  return state.roles.some(curRole => curRole === 'ROLE_ADMIN')
}

export const hasSuperRole = (state) => {
  return state.roles.some(curRole => curRole === 'ROLE_SUPER')
}

export const hasIdCardRole = (state) => {
  return state.roles.some(curRole => curRole === 'ROLE_IDCARD')
}
